export const vacancyData = {
  'digital-marketing-manager': {
    title: 'Digital Marketing Manager',
    description: `
      We are looking for a skilled and motivated Digital Marketer to work with us in developing and executing B2B marketing solutions.
      You will join a small team of highly driven individuals as the first marketing hire and have a big impact on the direction of our company.
      You own marketing, lead generation and content development, and you are responsible for growing and leading the marketing team.
    `,
    responsibilities: [
      'Develop and execute B2B marketing campaigns and grow brand awareness',
      'Create compelling marketing collateral that advocates our value added propositions and broadens customer engagement opportunity',
      'Develop interactive content (blogs, whitepapers, videos, etc.) to help professional traders meet their business challenges',
      'Maintain and enhance training and learning materials including guides, videos, etc.',
      'Collaborate closely with subject matter experts and key external partners to drive brand awareness and develop cross selling opportunities and lead generation'
    ],
    requirements: [
      'Bachelor’s degree, preferably in Marketing, Communications, Business Administration or Finance',
      '1+ years\' customer focused B2B marketing experience, preferably in financial industry',
      'Demonstrated knowledge of B2B campaign strategy & execution, digital strategy, messaging development, collateral development and thought leadership content development',
      'Motivated and passionate with an innovative and creative mindset',
      'Excellent writing skills',
      'Excellent communication skills, including the ability to convey technical ideas clearly and concisely.'
    ],
    'nice-to-have': [
      'Knowledge and experience in trading, technical analysis or fundamental analysis is a plus but not required.'
    ],
    benefits: [
      'Meaningful equity in a YC-backed, VC-funded startup',
      'Free health Insurance',
      'Positive, balanced work environment'
    ]
  },
  'front-end-software-engineer': {
    title: 'Front End Software Engineer',
    description: `
      We are looking for an experienced and motivated front-end developer to join us. You will be responsible for owning the client side of our product development and managing those
      projects to ensure timely and high quality development. You will have a bug impact on the direction of our front-end engineering.
    `,
    responsibilities: [

    ],
    requirements: [
      'Strong engineering leadership skills',
      '2+ years experience working full time as a Front-End Engineer',
      'Solid knowledge of popular JS frameworks',
      'HTML, CSS, Javascript',
      'Experience with data visualization libraries such as D3.js',
      'Best practices in testing',
      'Understanding of design principles',
      'Knowledge of data processing pipelines'
    ],
    'nice-to-have': [
      'Experience in building trading applications',
      'Fluency in Python/Django'
    ],
    benefits: [
      'Working on cutting edge technology in a lucrative industry alongside a passionate team',
      'Generous equity in a YC-backed, VC-funded startup',
      'Positive, Balanced work environment'
    ]
  },
  'full-stack-software-engineer': {
    title: 'Full Stack Software Engineer',
    description: `
      We are seeking a Full-stack engineer to join our growing team. As an early stage employee,
      you will work directly with the founders and have a strong voice in product and technology decisions.
    `,
    responsibilities: [

    ],
    requirements: [
      'Strong engineering leadership skills',
      '3+ years experience in web app development',
      'Comfortable working across the stack',
      'Technologically diverse background and ability/willingness to learn new things quickly',
      'Best practices in testing',
      'Knowledge of data processing pipelines'
    ],
    'nice-to-have': [
      'Experience in building trading applications',
      'Experience with data visualization libraries such as D3.js',
      'Fluency in Python/Django'
    ],
    benefits: [
      'Working on cutting edge technology in a lucrative industry alongside a passionate team',
      'Generous equity in a YC-backed, VC-funded startup',
      'Positive, Balanced work environment'
    ]
  },
  'data-scientist': {
    title: 'Data Scientist',
    description: `
      
    `,
    responsibilities: [

    ],
    requirements: [

    ],
    'nice-to-have': [

    ],
    benefits: [

    ]
  }
}
